import React from 'react';
import PropTypes from 'prop-types';
import { css, useTheme } from '@emotion/react';

import LayoutContainer from 'components/LayoutContainer';
import Headline from 'components/Text/Headline';
import * as styles from 'styles';

const HelpLayout = ({ title, children }) => {
  const theme = useTheme();

  return (
    <LayoutContainer
      css={css`
        display: flex;
        flex-direction: column;
        flex: 1;
      `}
    >
      <Headline
        css={css`
          margin: 80px auto 64px auto;
          color: ${theme.secondary};
          text-align: center;

          ::before {
            content: '';
            display: block;
            margin: 0 auto 36px;
            height: 5px;
            width: 55px;
            background: ${theme.primary};
          }

          ${styles.respondTo.mobile} {
            margin: 64px 20px 40px;
          }
        `}
      >
        {title}
      </Headline>
      <div
        css={css`
          display: flex;
          flex-flow: row wrap;
          margin: 40px 0 0;

          h2 {
            min-height: 64px;
            font-weight: 800;
            font-style: italic;
            font-size: 28px;
            line-height: 32px;
            letter-spacing: 0.8px;
            color: ${theme.secondary};
            margin-bottom: 20px;

            ${styles.respondTo.mobile} {
              min-height: 56px;
              font-size: 24px;
              line-height: 28px;
              letter-spacing: 0.6px;
            }
          }

          p,
          li {
            font-size: 16px;
            line-height: 28px;
            color: ${theme.secondary};

            ${styles.respondTo.mobile} {
              font-size: 14px;
              line-height: 24px;
            }
          }

          ul {
            margin: 10px 0;
          }

          article {
            margin-bottom: 64px;
            padding: 0 20px;
            width: 50%;

            ${styles.respondTo.mobile} {
              width: 100%;
            }
          }

          table {
            border-collapse: collapse;
            margin-top: 20px;
          }

          table,
          th,
          td {
            border: 1px solid ${theme.secondary};
            color: ${theme.secondary};
            font-size: 14px;
            text-align: left;
          }

          th,
          td {
            padding: 8px;
          }

          a {
            text-decoration: underline;
            color: ${theme.secondary};
          }
        `}
      >
        {children}
      </div>
    </LayoutContainer>
  );
};

HelpLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default React.memo(HelpLayout);
